import {
  Box,
  Menu,
  Modal,
  Text,
  TextInput,
  Button,
  Group,
  Grid,
  Input,
  Textarea,
  useMantineTheme
} from '@mantine/core';
import { useStyles } from './style';
import { useLocation } from 'react-router-dom';
import { BsTicketPerforated } from 'react-icons/bs';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { useContext, useEffect, useRef, useState } from 'react';
import { dataTypes, getLinks, properties } from './properties';
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '@mantine/hooks';
import { useDisclosure } from '@mantine/hooks';
import {
  clearUserData,
  doRedirectIfUnAuth,
  getHeader,
  getUserData,
  getUserType,
  updateLoggedInData
} from '../../../config/userSession';
import { TiContacts } from 'react-icons/ti';

import {
  AiOutlineFileText,
  AiOutlineSafetyCertificate,
  AiOutlineEye,
  AiOutlineRobot,
  AiOutlineBarChart,
  AiOutlineIdcard,
  AiOutlineContacts
} from 'react-icons/ai';
import logoUrl from '../../../assets/icons/tripleNet.svg';

import { useQuickstartContext } from '../../../context';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { useGetUser } from '../../../hooks/use-get-user';

export const Sidebar = ({ dataTypes, isOpen, toggleSidebar, accessLevels }) => {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  const userType = getUserType();
  const isMobile = useMediaQuery('(max-width: 768px)'); // Detect mobile screens
  const userData = useGetUser();
  const [loading, setLoading] = useState(false);
  const hasInviteAccess =
    accessLevels?.includes('Admin') || accessLevels?.includes('Group Manager');
  const [opened, { open, close }] = useDisclosure(false);
  const [pending, setPending] = useState(false);
  const [accessModalOpen, setAccessModalOpen] = useState(false);
  const [requestedFeature, setRequestedFeature] = useState('');
  const user = getUserData();

  const IDPACCESS = userData?.user?.UserAttributes?.find(
    (attr) => attr.Name === 'custom:idp_access'
  )?.Value;
  const ASSISTANTACCESS = userData?.user?.UserAttributes?.find(
    (attr) => attr.Name === 'custom:assistant_access'
  )?.Value;
  useEffect(() => {
    if (!accessModalOpen) {
      setPending(false);
    }
  }, [accessModalOpen]);
  const handleRequestAccess = (featureName) => {
    setRequestedFeature(featureName);

    if (featureName === 'IDP' && IDPACCESS === 'PENDING') {
      setPending(true);
    } else if (featureName === 'Assistant' && ASSISTANTACCESS === 'PENDING') {
      setPending(true);
    }
    setAccessModalOpen(true);
  };

  const isDarkMode = false;
  const location = useLocation();
  if (isMobile && !isOpen) {
    return null;
  }

  const sendRequestAccess = async () => {
    setLoading(true);
    const { email, firstName, lastName, userType } = user;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/access/access-request`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...getHeader()
          },
          body: JSON.stringify({
            email,
            firstname: firstName,
            lastname: lastName,
            restrictedFeature: requestedFeature,
            role: userType
          })
        }
      );
      if (!response.ok) {
        throw new Error('Failed to send access request');
      }
      const newattributeName =
        requestedFeature == 'IDP' ? 'idp_access' : 'assistant_access';
      const data = await response.json();
      const awsresponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/account/send-access-request`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            ...getHeader()
          },
          body: JSON.stringify({
            email,
            attributeName: newattributeName,
            value: 'PENDING'
          })
        }
      );
      if (awsresponse.status == 200) {
        setAccessModalOpen(false);
        setLoading(false);
        userData.getUser();
      }
    } catch (error) {
      setLoading(false);
      console.error('Error sending access request:', error);
    }
  };
  return (
    <>
      {/* <SeeSomethingSaySomethingPopup opened={opened} close={close} /> */}
      <Box
        // className={`${classes.sidebar} ${isOpen ? classes.sidebarOpen : ''} ${
        //   isDarkMode ? classes.darksidebar : ''
        // }`}
        style={{ width: '300px', padding: '10px' }}
      >
        <Box className={classes.sidebarHeader}>
          <AiOutlineClose
            className={classes.closeIcon}
            onClick={toggleSidebar}
          />
        </Box>
        <Box className={classes.sidebarLinks}>
          <img
            className={classes.logo}
            src={logoUrl}
            alt="logo"
            style={{ paddingBottom: '60px' }}
          />
          <NavLink
            to={`${userType?.toLowerCase()}/`}
            end
            style={{
              color:
                location.pathname.replace(/\//g, '') ===
                `${userType.toLowerCase()}`
                  ? '#ffffff'
                  : !isDarkMode
                    ? '#010712'
                    : '#ffffff',
              underline: 'none',
              background:
                location.pathname.replace(/\//g, '') ===
                `${userType.toLowerCase()}`
                  ? `${theme.colors.primary[0]}`
                  : 'transparent',
              padding: '10px',
              textDecoration: 'none',
              outline: 'none',
              borderRadius: '10px',
              alignItems: 'center',
              display: 'flex',
              gap: '6px'
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3"
                y="3"
                width="8"
                height="8"
                rx="2"
                fill="currentColor"
              />
              <rect
                x="13"
                y="3"
                width="8"
                height="8"
                rx="2"
                fill="currentColor"
              />
              <rect
                x="3"
                y="13"
                width="8"
                height="8"
                rx="2"
                fill="currentColor"
              />
              <rect
                x="13"
                y="13"
                width="8"
                height="8"
                rx="2"
                fill="currentColor"
              />
            </svg>
            Dashboard
          </NavLink>

          {getLinks(userType)?.map((element) => {
            const isActive =
              location.pathname === element.link ||
              location.pathname.startsWith(element.link + '/');
            return (
              <NavLink
                key={element.link}
                style={{
                  color: isActive
                    ? '#ffffff'
                    : !isDarkMode
                      ? '#010712'
                      : '#ffffff',
                  underline: 'none',
                  background: isActive
                    ? `${theme.colors.primary[0]}`
                    : 'transparent',
                  padding: '10px',
                  outline: 'none',
                  borderRadius: '10px',
                  textDecoration: 'none',
                  alignItems: 'center',
                  display: 'flex',
                  gap: '6px'
                }}
                to={element.link}
              >
                {element.icon}
                {element.title}
              </NavLink>
            );
          })}
          <NavLink
            to={
              ASSISTANTACCESS === 'APPROVED'
                ? `${userType.toLowerCase()}/assistant`
                : '#'
            }
            style={{
              color: location.pathname.includes('assistant')
                ? '#ffffff'
                : !isDarkMode
                  ? '#010712'
                  : '#ffffff',
              textDecoration: 'none',
              background: location.pathname.includes('assistant')
                ? `${theme.colors.primary[0]}`
                : 'transparent',
              padding: '10px',
              outline: 'none',
              borderRadius: '10px',
              alignItems: 'center',
              display: 'flex',
              gap: '6px'
            }}
            onClick={(e) => {
              if (ASSISTANTACCESS === 'PENDING') {
                e.preventDefault();
                handleRequestAccess('Assistant');
                setPending(true);
                return;
              } else if (ASSISTANTACCESS !== 'APPROVED') {
                e.preventDefault();
                handleRequestAccess('Assistant');
                return;
              }

              if (isMobile) toggleSidebar();
            }}
          >
            <AiOutlineRobot size={24} />
            AI Chatbot
          </NavLink>
          <NavLink
            to={
              IDPACCESS === 'APPROVED'
                ? `${userType.toLowerCase()}/documents`
                : '#'
            }
            style={{
              pointerEvents: 'auto',
              color: location.pathname.includes('documents')
                ? '#ffffff'
                : !isDarkMode
                  ? '#010712'
                  : '#ffffff',
              underline: 'none',
              background: location.pathname.includes('documents')
                ? `${theme.colors.primary[0]}`
                : 'transparent',
              padding: '10px',
              outline: 'none',
              borderRadius: '10px',
              textDecoration: 'none',
              alignItems: 'center',
              display: 'flex',
              gap: '6px'
            }}
            onClick={(e) => {
              if (IDPACCESS !== 'APPROVED') {
                e.preventDefault();
                handleRequestAccess('IDP');
                return;
              } else if (IDPACCESS === 'PENDING') {
                e.preventDefault();
                handleRequestAccess('IDP');
                setPending(true);
                return;
              }
              if (isMobile) toggleSidebar();
            }}
          >
            <AiOutlineFileText size={24} />
            IDP
          </NavLink>
        </Box>
      </Box>
      <Modal
        opened={accessModalOpen}
        onClose={() => setAccessModalOpen(false)}
        centered
        withCloseButton
        size="md"
        title="Request Access"
        backgroundColor="#00d095"
      >
        <Text size="sm" mb="md" color="dimmed">
          {pending ? (
            <>
              You have already requested access to{' '}
              <Text span weight={600} color="black">
                {requestedFeature}
              </Text>
              . Our team will get back to you shortly.
            </>
          ) : (
            <>
              You do not currently have access to{' '}
              <Text span weight={600} color="black">
                {requestedFeature}
              </Text>
              .
            </>
          )}
        </Text>

        <Box
          mt="lg"
          sx={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}
        >
          <Button
            variant="default"
            disabled={loading}
            onClick={() => setAccessModalOpen(false)}
          >
            {pending ? 'Close' : 'Cancel'}
          </Button>

          {!pending && (
            <Button
              disabled={loading}
              styles={{
                root: {
                  backgroundColor: 'black',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#333'
                  }
                }
              }}
              onClick={sendRequestAccess}
            >
              {loading ? 'Sending Request...' : 'Request'}
            </Button>
          )}
        </Box>
      </Modal>
    </>
  );
};
